export default [
    {
        path: "ip-bundle-lists",
        name: "ipbundlelists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/IpBundleList.vue"
            ),
        meta: {
            title: `ip bundle list`,
        },
    },
    {
        path: "add-ip-bundle",
        name: "addipbundle",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/AddIpBundle.vue"
            ),
        meta: {
            title: `Add New ip bundle`,
        },
    },
    {
        path: "edit-ip-bundle/:id",
        name: "editipbundle",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/AddIpBundle.vue"
            ),
        meta: {
            title: `ip bundle list`,
        },
    },
    {
        path: "ip-bundle-details-lists/:id",
        name: "IpBundleDtlsLists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/IpBundleDtlsList.vue"
            ),
        meta: {
            title: `ip bundle list`,
        },
    }
];
